import type { FaireProductEntity } from "../../entity_types/product";

export const p_jj3ytjpuvu: FaireProductEntity = {
  token: "p_jj3ytjpuvu",
  type: "product",
  name: "Juniper Beer Glass",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/3e52e76cc7bc7727be8098cb19780d216ec86aebbe17a5e18621d4ef45eb3ba8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87e51281039eed22ef5ed60cc91543566e5fb16816961f179619cd9af80c3d2e.jpeg",
  ],
  priceDollars: 18.75,
  description:
    'Juniper is a sculptural glassware range designed to elevate the drinking experience by enhancing both flavour and aroma. The glasses are graphic in form yet functional and satisfying to use, and their striking geometric silhouette adds interest to any table, bar or drinks trolley.\n\nJuniper Beer Glass\n• Size: Ø 9.2 x H 12.7 cm / Ø 3.6" x H 5"\n• Capacity: 460 ml / 15.5 fl oz\n\n• Packed as a set of 2\n\n• Colour: clear',
  tags: [],
  msrpDollars: 37.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:23.362Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
